import React from "react";
import { Link } from "react-router-dom";

const CompanyCard = ({ company, url }) => {
  return (
    <div className="col-md-4 mb-4">
      <div className="card h-100 shadow">
        <div className="card-body">
          <h5>{company.companyName}</h5>
          <p>Contact Person: {company.contactPerson}</p>
          <p>Address: {company.district}</p>
          <p>Transportation: {company.transportType}</p>

          <Link
            to={`/${url}/${company.id}`}
            className="btn btn-primary btn-sm"
          >
            View Details
          </Link>
        </div>
      </div> 
    </div>
  );
};

export default CompanyCard;